<template lang="pug">
  v-menu(v-model="display" :position-x="x",:position-y="y")
    v-list(dense)
      v-list-tile(@click="openCardDetailDialog")
        v-list-tile-action
          v-icon() info
        v-list-tile-content カード詳細
      //v-list-tile(@click="openDynamicResultDialog" v-show="!isResult")
        v-list-tile-action
          v-icon() work
        v-list-tile-content 実績登録
      //v-list-tile(@click="dynamicResultRelease" v-show="isResult")
        v-list-tile-action
          v-icon() work_off
        v-list-tile-content 実績解除
</template>

<script>
export default {
  data() {
    return {
      display: false,
      x: 0,
      y: 0,
      item: {}
    };
  },
  computed: {
    isResult() {
      return this.item.isResult;
    }
  },
  methods: {
    open(data) {
      this.item = data.item;
      // TODO tickイベント実装？（既に開いていると別のが開かない。二回押下で開くので）
      this.display = false;
      this.x = data.event.clientX;
      this.y = data.event.clientY;
      this.display = true;
    },
    openCardDetailDialog(event) {
      this.$emit("openCardDetailDialog", this.item);
    },
    openDynamicResultDialog(event) {
      this.$emit("openDynamicResultDialog", this.item);
    },
    dynamicResultRelease(event) {
      this.$emit("dynamicResultRelease", this.item);
    }
  }
};
</script>
